import React, { ButtonHTMLAttributes } from 'react';
import { Download as DownloadIcon } from 'lucide-react';

import { SecondaryButton } from '../button/Button';

export type DownloadButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    buttonClassName?: string;
    iconClassName?: string;
    displayLabel?: boolean;
};

const DownloadButton = (props: DownloadButtonProps) => {
    const { className, buttonClassName, iconClassName, onClick, displayLabel = true } = props;

    const buttonLabel = (
        <>
            {displayLabel && <span>Download</span>}
            <DownloadIcon className={iconClassName} />
        </>
    );

    return (
        <div className={className}>
            <SecondaryButton onClick={onClick} className={buttonClassName}>
                {props.children || buttonLabel}
            </SecondaryButton>
        </div>
    );
};

export default DownloadButton;
